<!-- <app-loading></app-loading> -->
<div class="gates-container">
    <div *ngIf="loading" class="loading">
        <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
    <div *ngIf="!loading">
        <ng-container *ngIf="gates.length > 0">
            <div class="control-bar" >
                <app-control-bar [listType]="'gates'" [marginToggleViewLeft] = 'true'></app-control-bar>
            </div>
            <div class="list-container">
                <div class="gates-list" *ngIf="rowsView == 'list'">
                    <app-gate-card *ngFor="let gate of gates" [gate]="gate"></app-gate-card>
                </div>

                <div class="gates-list" *ngIf="rowsView == 'compact'">
                    <app-table-view [controls]="tableControls" (eventHandeler)="tableEventHandeler($event)"></app-table-view>
                </div>
                <div class="overview-list" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                    <app-overview [type]="'gates'" [controls]="overviewData"
                        (eventHandler)="overviewEventHandler($event)">
                    </app-overview>
                </div>
            </div>
        </ng-container>
        <div *ngIf="gates.length === 0">
            <div class="no-gates">
                <label>{{'gates.no-gates' | translate}}</label>
                <button (click)="addGate()" class="btn btn-primary">{{'gates.add-gate' | translate}}</button>
            </div>
        </div>
    </div>
</div>
<app-add-gate></app-add-gate>
<app-assign-gate-modal></app-assign-gate-modal>
